import React, { useMemo } from 'react';
import DayJs from 'utils/Dayjs';
import { EXAM_STUDENT_STATES } from 'utils/Constants';

import Show from 'components/Show';
import Pill from 'components/Misc/Pill';
import Avatar from 'components/Misc/Avatar';
import { Title, Mark } from 'components/Misc/Typography';
import { Button } from 'components/Misc/Form';

const Student = ({ take }) => {
	// Find status info
	const state = useMemo(() => EXAM_STUDENT_STATES.find(state => state.value === take.state), [take.state]);

	return (
		<div className="py-3 px-4 flex items-center space-x-2">
			<Avatar
				alt={take.student.fullName}
				src={take.student.avatar}
			/>

			<Title
				title={take.student.fullName}
				className="flex-1"
			/>

			<Show if={take.endedAt}>
				<Pill name={`${DayJs(take.endedAt).format('D. MMMM, YYYY HH:mm')}`} />
			</Show>

			<Pill theme={state.theme} name={state.text} />

			<Show if={take.state === 'reviewed' || take.state === 'rejected'}>
				<Mark mark={take.mark} />
			</Show>

			<Button
				small
				square
				icon="edit"
				to={`/exams/results/review/${take.examId}/${take.id}`}
			/>
		</div>
	);
};

export default Student;